import { FotAuthStore } from "imagica-corekit/dist/base/store/FotAuthStore";
import { getIt } from "@uikit/getIt";

function useDownloadMeta() {
  const downloadMetaData = async url => {
    try {
      const token = getIt(FotAuthStore).state.brainToken;
      const response = await fetch(url, {
        headers: {
          Authorization: `token ${token}`,
        },
      });
      const blob = await response.blob();
      const rUrl = URL.createObjectURL(blob);
      URL.revokeObjectURL(blob);
      return rUrl;
    } catch (error) {
      console.error(error);
    }
  };

  return [downloadMetaData];
}

export default useDownloadMeta;
